module.exports = __webpack_public_path__ + "static/img/1-1.a5d89bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/eng/1-1.png
// module id = IBWa
// module chunks = 0